import React, { PureComponent } from 'react';
import moment from 'moment';

import './style.scss';
import Table from '../../../../components/table';
import { connect } from 'react-redux';
import { ACTIONS, getTeamSchedule, convertDataSchedule } from './../../../../actions/team-schedule';
import { ACTIONS_MASTER, getYearData } from './../../../../actions/master';
import Loading from '../../../../components/loading';
import { month } from './../../../../common/enum/index';

class TeamSchedule extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            dataSchedule : [],
            yearData : [],
            monthData: month,
            showLoading: false,
            year_id: null,
            month_id: moment().format('MM'),
            teamId: null
        }
        this.onRedirect = this.onRedirect.bind(this);
    }

    componentDidMount() {
        this.setState({showLoading: true, teamId: this.props.match.params.id});
        this.props.getYearData().then(response => {
            this.props.getTeamSchedule({
                month_id: this.state.month_id,
                year_id: response[0].year_id,
                team_id: this.props.match.params.id
            });
            this.setState({ year_id: response[0].year_id });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_INFO_TEAM_SCHEDULE_SUCCESS) {
                this.setState({
                    dataSchedule: convertDataSchedule(nextProps.response),
                    showLoading: false
                })
            }
            if (nextProps.statusYear === ACTIONS_MASTER.GET_YEAR_SUCCESS) {
                this.setState({
                    yearData: nextProps.responseYear,
                })

            }
       }
    }

    getYearData(e) {
        this.setState({
            year_id: e.target.value,
            showLoading: true
        }, () => {
            const data = {
                month_id: this.state.month_id,
                year_id: this.state.year_id,
                team_id: this.state.teamId
            }
            this.props.getTeamSchedule(data);
        })
    }

    activeMonth(idMonth) {
        this.setState({
            showLoading: true,
            month_id: idMonth
        }, () => {
            const data = {
                month_id: this.state.month_id,
                year_id: this.state.year_id,
                team_id: this.state.teamId
            }
            this.props.getTeamSchedule(data);
        })
    }

    onRedirect(value) {
        this.props.history.push(`/game/${value.id}/${this.state.teamId}/${value.game_date}?complete=${value.complete}`);
    }

    render() {
        return (
            <div className="team-schedule">
                <div className="wrapper">
                    <div className="block-control">
                    <select className="form-control" onChange={(e) => this.getYearData(e)}>
                            {
                                this.state.yearData.map((v, i) => {
                                    return <option key={i} value={v.year_id}>{ v.year }</option>
                                })
                            }
                        </select>
                        <div className="block-control__button">
                            {
                                this.state.monthData.map((val, i) => {
                                    return <button key={i} onClick={() => this.activeMonth(val.id)}  type="button" className={`btn-radius ${val.id === this.state.month_id ? 'active' : ''}`}>{ val.month }</button>
                                })
                            }
                        </div>
                    </div>
                    <Table
                        header={this.props.header}
                        showCheckbox={false}
                        showSearch={false}
                        itemOfPage={this.state.dataSchedule}
                        isShowOptionTable={false}
                        showPagination={false}
                        onRowClick={(value) => this.onRedirect(value)}
                    />
                </div>

                <Loading show={this.state.showLoading} />
            </div>
        );
    }
}

const mapStateToProps = ({ teamSchedule, master }) => {
    return {
        header: teamSchedule.headerTable,
        status: teamSchedule.status,
        response: teamSchedule.response,
        responseYear: master.response,
        statusYear: master.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getTeamSchedule: (data) => {
            dispatch(getTeamSchedule(data));
        },
        getYearData: () => dispatch(getYearData()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(TeamSchedule);
